import React from 'react';
import { Box } from '@mui/material';
// src
import HelpBox from '@foxtons/fdl/layouts/HelpBox/index';
// utils&styles
import { NewHomesHelpBoxProps } from 'types/NewHomesDetailPage';

export interface LibMoreInfoProps {
  information: NewHomesHelpBoxProps;
  setIsArrangeViewingDrawerOpen: () => void;
}

function MoreInfo({
  information,
  setIsArrangeViewingDrawerOpen
}: LibMoreInfoProps) {
  const handleArrangeViewing = () => {
    setIsArrangeViewingDrawerOpen();
  };

  return (
    <Box>
      <HelpBox
        richTextLeft={information?.Title}
        richTextRight={information?.Text}
        btnPrimary={{
          label: information?.Buttons[0]?.label || '',
          handleClickPrimary: handleArrangeViewing
        }}
        variant="green"
        isSearchBox={information?.HasSearchBox}
      />
    </Box>
  );
}

export default MoreInfo;
